import { useTranslation } from "react-i18next";
import SEOHead from "@/components/SEOHead";
import HeroSection from "@/components/home/HeroSection";
import ManifestoSection from "@/components/home/ManifestoSection";
import PlatformDivisions from "@/components/home/PlatformDivisions";
import TechnologySection from "@/components/home/TechnologySection";
import HardwareBand from "@/components/home/HardwareBand";
import VisionBand from "@/components/home/VisionBand";
import BarcelonaSection from "@/components/home/BarcelonaSection";
import PressSection from "@/components/home/PressSection";
import FloatingCTA from "@/components/FloatingCTA";


const Home = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEOHead
        title={t('sHome.home.seoTitle')}
        description={t('sHome.home.seoDescription')}
      />

      <HeroSection />
      <ManifestoSection />

      <PlatformDivisions />
      <TechnologySection />
      <HardwareBand />
      <VisionBand />
      <BarcelonaSection />
      <PressSection />

      <FloatingCTA />

    </>
  );
};

export default Home;
